const SortIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="15"
      viewBox="0 0 16 15"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.48486 11.4226L11.5816 14.7559C11.884 15.0813 12.3741 15.0813 12.6765 14.7559L15.7732 11.4226C16.0756 11.0971 16.0756 10.5696 15.7732 10.2441C15.4709 9.91867 14.9808 9.91867 14.6784 10.2441L12.9032 12.1548V0.833333C12.9032 0.3731 12.5566 0 12.1291 0C11.7015 0 11.3549 0.3731 11.3549 0.833333V12.1548L9.57968 10.2441C9.27733 9.91867 8.78721 9.91867 8.48486 10.2441C8.18252 10.5696 8.18252 11.0971 8.48486 11.4226ZM4.41841 0.244078C4.11607 -0.0813558 3.62587 -0.0813558 3.32353 0.244078L0.226754 3.57741C-0.0755847 3.90284 -0.0755847 4.43049 0.226754 4.75592C0.529093 5.08136 1.01929 5.08136 1.32163 4.75592L3.09678 2.84518V14.1667C3.09678 14.6269 3.4434 15 3.87097 15C4.29854 15 4.64517 14.6269 4.64517 14.1667V2.84518L6.42034 4.75592C6.72269 5.08136 7.21281 5.08136 7.51516 4.75592C7.81751 4.43049 7.81751 3.90284 7.51516 3.57741L4.41841 0.244078Z"
        fill="#183883"
      />
    </svg>
  );
};
export default SortIcon;
